var CalculatorClaimsMonitoring = (function($) {

    // Elements...
    var $calculator, $group1, $group2, $group3,
        $slider1, $slider2, $slider3,
        $text1, $text2, $text3,
        $handle1, $handle2, $handle3,
        $result;

    // Calculation constraints...
    var constraints = {
      working_minutes_per_year: 60 * 8 * 5 * 52,
      time_savings: 0.85,
    };

    // Slider config...
    var slider_config = {
        orientation: 'horizontal',
        range: 'min',
        slide: function() {
            calculate()
        },
        stop: function() {
            calculate()
        },
    };

    /**
     * Configure calculator...
     */
    function init() {
        $calculator = $('[data-calculator="claims-monitoring"]');
        $group1  = $('[data-slider-group=1]', $calculator);
        $group2  = $('[data-slider-group=2]', $calculator);
        $group3  = $('[data-slider-group=3]', $calculator);

        $slider1 = $('[data-slider]', $group1);
        $slider2 = $('[data-slider]', $group2);
        $slider3 = $('[data-slider]', $group3);

        $text1   = $('[data-slider-text]', $group1);
        $text2   = $('[data-slider-text]', $group2);
        $text3   = $('[data-slider-text]', $group3);

        $handle1 = $('[data-slider-handle]', $group1);
        $handle2 = $('[data-slider-handle]', $group2);
        $handle3 = $('[data-slider-handle]', $group3);

        $result  = $('[data-result=1]', $calculator);

        // Configure sliders...
        $slider1.slider($.extend(slider_config, {
            min:   1,
            max:   10000,
            value: 5000,
            // step:  500,
            create: function() {
                $handle1.text('<  >');
            }
        }));

        $slider2.slider($.extend(slider_config, {
            min:   1,
            max:   100,
            value: 10,
            // step:  10,
            create: function() {
                $handle2.text('<  >');
            }
        }));

        $slider3.slider($.extend(slider_config, {
            min:   25000,
            max:   100000,
            value: 50000,
            // step:  1000,
            create: function() {
                $handle3.text('<  >');
            }
        }));

        // Calculate for initial load...
        calculate();
    }

    /**
     * Calculate values...
     */
    function calculate() {
        var monthly = ($slider1.slider('value') * constraints.time_savings)
                      * (($slider3.slider('value') / constraints.working_minutes_per_year) * $slider2.slider('value'));
        var result = monthly * 12;

        // Populate outputs...
        $text1.html($slider1.slider('values', 5000).toLocaleString());
        $text2.html($slider2.slider('values', 10).toLocaleString());
        $text3.html('$' + $slider3.slider('values', 50000).toLocaleString());
        $result.html('$' + Math.round(result).toLocaleString());
    }

    return {
        init: init,
    }

})(jQuery);

jQuery(document).ready(function() {
    CalculatorClaimsMonitoring.init();
});